import React, { useState, useEffect } from 'react';
//import './navbar.css';
//import '../App.css';

import axios from "axios";
import { Button, Row, Col } from 'react-bootstrap';
import Localizzazione_sulla_mappa from "./Maps_inserita_nei_form.jsx";
import Scelta_tipologia_azienda from "./Ditta_x6_tipologia.jsx";



const Ditta_Form_Base = (props) => {

    const [variab_aggiorna, SET_variab_aggiorna] = useState('');
    const [end_Date, set_End_Date] = useState(new Date());
    const [input, setInput] = useState({
        nome: '',
        cognome: '',
        luogo_nascita: '',
        email: ''
    });


    useEffect(() => {
        console.log('USEEFFECT')

        axios.get('/ditte/trova_ditta/' + props.id)
            .then((res) => {
                console.log('domande appena fecciate da mongo')
                //                console.log(res.data)
                setInput(res.data)
                console.log(res.data.data_nascita)
                var dateObj = new Date(res.data.data_nascita);
                set_End_Date(dateObj)
            }).catch((error) => {
                console.log(error)
            });
    }, []);



    function handleChange(event) {
        const { name, value } = event.target;
        console.log('sssssss')

        console.log(end_Date)
        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        })
    }


    function handleClick(event) {
        event.preventDefault();
        //        console.log(input);
        //        const new_ditta = {
        //            ...input,
        //            data_nascita: end_Date
        //        }
        //        console.log(new_alunno);
        //        axios.post('http://localhost:3001/create', newNote)

        axios.patch('/ditte/ditta_modifica/' + props.id, input)
            .then((res) => {
                console.log(res.data)
            }).catch((error) => {
                console.log(error)
            });
        props.setShow(false)
        //            variab_aggiorna = {variab_aggiorna} SET_variab_aggiorna={SET_variab_aggiorna}
    }


    return (
        
    <div className='container'>
    
        <h2>Form Ditta</h2>
            <div className='rettangolo_rosso'>
                <h5>Dati Generici Ditta</h5>
                <Row>
                <Scelta_tipologia_azienda setInput = {setInput} input={input}/>
              
                </Row>
                    <Row>
                        <Col>
                            <label>Ragione Sociale</label>
                            <input onChange={handleChange} placeholder="Nome della ditta" name="ragione_sociale" value={input.ragione_sociale} autoComplete="off" className="form-control"></input>
                        </Col>
                        <Col>
                            <label>Cf/Partita Iva</label>
                            <input onChange={handleChange} placeholder="" name="partita_iva" value={input.partita_iva} autoComplete="off" className="form-control"></input>
                        </Col>
                    </Row>
                <p>
                    <Row>
                        <Col>
                            <label>Email per comunicazioni</label>
                            <input onChange={handleChange} placeholder="Email" name="email" value={input.email} autoComplete="off" className="form-control"></input>
                        </Col>

                    </Row>
                </p>

                <p>
                    <Row>
                        <span>Indirizzo della ditta</span>
                    </Row>
                    <Row>
                        <Col>
                            <label>Indirizzo</label>
                            <input onChange={handleChange} placeholder="Via, Piazza, Vicolo " name="ditta_indirizzo_via" value={input.ditta_indirizzo_via} autoComplete="off" className="form-control"></input>
                        </Col>
                        <Col>
                            <label>Civico</label>
                            <input onChange={handleChange} placeholder="Civico " name="ditta_indirizzo_civico" value={input.ditta_indirizzo_civico} autoComplete="off" className="form-control"></input>
                        </Col>
                        <Col>
                            <label>Città </label>
                            <input onChange={handleChange} placeholder="Città" name="ditta_indirizzo_citta" value={input.ditta_indirizzo_citta} autoComplete="off" className="form-control"></input>
                        </Col>
                    </Row>
                </p>
            </div>
            <div>
                <Localizzazione_sulla_mappa indirizzo ={input} />
            </div>
            <div className='rettangolo_rosso'>
                <h5>Dati del titolare o legale rappresentante</h5>
                <p>
                    <Row>
                        <Col>
                            <label>Cognome</label>
                            <input onChange={handleChange} placeholder="Cognome" name="cognome" value={input.cognome} autoComplete="off" className="form-control"></input>
                        </Col>
                        <Col>
                            <label>Nome</label>
                            <input onChange={handleChange} placeholder="Nome" name="nome" value={input.nome} autoComplete="off" className="form-control"></input>
                        </Col>
                    </Row>
                </p>
                <p>
                    <Row>
                        <Col>
                            <label>Luogo di nascita</label>
                            <input onChange={handleChange} placeholder="Città di nascita" name="luogo_nascita" value={input.luogo_nascita} autoComplete="off" className="form-control"></input>
                        </Col>
                        <Col>
                            <label>Data di nascita</label>
                            <input onChange={handleChange} placeholder="00/00/0000" name="data_nascita" value={input.data_nascita} autoComplete="off" className="form-control"></input>
                        </Col>

                    </Row>
                </p>
                <p>
                    <Row>
                        <Col>
                            <label>Codice fiscale</label>
                            <input onChange={handleChange} placeholder="Codice fiscale Persona Fisica" name="codice_fiscale" value={input.codice_fiscale} autoComplete="off" className="form-control"></input>
                        </Col>
                    </Row>
                </p>

                <p>
                    <Row>
                        <span>Indirizzo di Residenza</span>
                    </Row>
                    <Row>
                        <Col>
                            <label>Indirizzo</label>
                            <input onChange={handleChange} placeholder="Via, Piazza, Vicolo " name="indirizzo_via" value={input.indirizzo_via} autoComplete="off" className="form-control"></input>
                        </Col>
                        <Col>
                            <label>Civico</label>
                            <input onChange={handleChange} placeholder="Civico " name="indirizzo_civico" value={input.indirizzo_civico} autoComplete="off" className="form-control"></input>
                        </Col>
                        <Col>
                            <label>Città </label>
                            <input onChange={handleChange} placeholder="Città" name="indirizzo_citta" value={input.indirizzo_citta} autoComplete="off" className="form-control"></input>
                        </Col>
                    </Row>
                </p>

            </div>

        <div className="d-flex flex-column-reverse">
            <Button onClick={handleClick} className="btn btn-lg btn-info">Salva</Button>
        </div>
    
    </div>
        
    );
}
export default Ditta_Form_Base;